import React from 'react';
import {Link} from 'react-router-dom';
import {ShowIf} from 'components/utils';
import {DateTime} from 'components/UI/DateTime';
import truncate from 'lodash/truncate';

class ItemDemand extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="need-offer-item-wrap">
        <div className="need-offer-item-content">
          <div className="box-pull-left">
            <p className="need-offer-item-desc mb10">
              {truncate(this.props.content, {length: 250, separator: ' '})}
            </p>
          </div>
          <div className="box-pull-left">
            <Link to={`/user/my-posted-demands/${this.props.id}`} className="need-offer-item-link">&nbsp;xem chi tiết</Link>
          </div>
          <div className="box-pull-left clear-left">
            <span className="need-offer-item-bold mr25">
              <DateTime dateTime={this.props.createdAt}/>
            </span>
          </div>
          <div className="box-pull-left clear-left">
            <span className="need-offer-item-desc mr25">
              <span className="need-offer-item-bold">Nhóm sản phẩm:&nbsp;</span>
              {
                this.props.categories.map((category, idx) => {
                  return (
                    <span className="category">
                      <Link className="category-demand" to={`/list-products/${category.id}`} target="_blank">{category.name}</Link>
                      <ShowIf condition={this.props.categories.length > idx + 1}>
                        <span> / </span>
                      </ShowIf>
                    </span>
                  );
                })
              }
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default ItemDemand;



// WEBPACK FOOTER //
// ./components/users/my-demand-content/ItemDemand.jsx